import { trackEvent } from '@otto-ec/nexus-registry/pdp/tracking';
import { DataContainer, submitEvent } from '@otto-ec/tracking-bct';
import { getProductFeaturesForNonPdpPage } from '../../../_common/client/tracking/get-product-features-for-non-pdp-page';

export function registerEventTracking(variationId: string) {
    trackEvent.assignFunction((trackingData: DataContainer) => {
        submitEvent(trackingData, {
            name: 'click',
            features: getProductFeaturesForNonPdpPage(variationId),
        });
    });
}
